import React, { useRef } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import '@/assets/scss/pages/invoices.scss'
import { trans } from '../../../../_providers/Translation'
import useReservationInvoices from '../../../../_helpers/useReservationInvoices'

//modals
import AddInvoice from './modals/AddInvoice'

//partials
import InvoicesTable from '../../../partials/InvoicesTable'

function Invoices(props) {

    const newInvoiceModalRef = useRef(null)

    const params = useParams()
    const history = useHistory()

    const id = params.id

    const { invoices, loading, refresh } = useReservationInvoices(id)

    const refreshData = () => {
        refresh()

        props.refreshData()
    }

    const handleAdd = () => {
        newInvoiceModalRef.current.open(id)
    }

    const handleDelete = () => {
        history.push(`?tab=invoices&indicator=${new Date().getTime()}`)
    }

    return (
        <div id='reservation-invoices'>
            <AddInvoice
                ref={newInvoiceModalRef}
                data={props.data}
                refreshData={refreshData}
            />
            <div className='pannel'>

                <div className='head'>
                    <div className='left'>
                        {trans('tabs.invoices')}
                    </div>
                    <div className='right'>
                        {props.data.can_modify && props.data && props.data.can_generate_invoice &&
                            <button className="button button-add button-small" onClick={handleAdd}>
                                {trans('buttons.newDocument')}
                            </button>
                        }
                    </div>
                </div>

                <InvoicesTable
                    loading={loading}
                    invoices={invoices}
                    canModify={props.data.can_modify}
                    refreshData={refreshData}
                    handleDelete={handleDelete}
                />

            </div>
        </div>
    )
}

export default Invoices